/*
 * File: XParser.js
 * ----------------
 * This file implements a parser for standard JavaScript/Java/C/C++
 * arithmetic expressions.
 */

 import Parser from './Parser.js'

function XParser() {
   Parser.call(this);
   this.scanner.addWordCharacters("_");
   this.defineOperators();
}
XParser.prototype = new Parser;
XParser.prototype.constructor = XParser;

function assert(bool) {
   if(!bool) {
      console.error('Assertion failed!')
   }
}

XParser.prototype.defineOperators = function() {
   this.definePrefixOperator("(", this.parenOperator, 0, "RIGHT");
   this.definePrefixOperator("+", this.prefixOperator, 100);
   this.definePrefixOperator("-", this.prefixOperator, 100);
   this.definePrefixOperator("!", this.prefixOperator, 100);
   this.definePrefixOperator("++", this.prefixOperator, 100, "RIGHT");
   this.definePrefixOperator("--", this.prefixOperator, 100, "RIGHT");
   this.defineInfixOperator("(", this.applyOperator, 110, "RIGHT");
   this.defineInfixOperator("+", this.infixOperator, 80);
   this.defineInfixOperator("-", this.infixOperator, 80);
   this.defineInfixOperator("++", this.suffixOperator, 100, "RIGHT");
   this.defineInfixOperator("--", this.suffixOperator, 100, "RIGHT");
   this.defineInfixOperator("*", this.infixOperator, 90);
   this.defineInfixOperator("/", this.infixOperator, 90);
   this.defineInfixOperator("%", this.infixOperator, 90);
   this.defineInfixOperator("<", this.infixOperator, 60);
   this.defineInfixOperator("<=", this.infixOperator, 60);
   this.defineInfixOperator(">", this.infixOperator, 60);
   this.defineInfixOperator(">=", this.infixOperator, 60);
   this.defineInfixOperator("==", this.infixOperator, 50);
   this.defineInfixOperator("!=", this.infixOperator, 50);
   this.defineInfixOperator("&&", this.infixOperator, 30);
   this.defineInfixOperator("||", this.infixOperator, 20);
   this.defineInfixOperator("?", this.questionMarkColon, 15, "RIGHT");
   this.defineInfixOperator("=", this.infixOperator, 10, "RIGHT");
   this.defineInfixOperator("+=", this.infixOperator, 10, "RIGHT");
   this.defineInfixOperator("-=", this.infixOperator, 10, "RIGHT");
   this.defineInfixOperator("*=", this.infixOperator, 10, "RIGHT");
   this.defineInfixOperator("/=", this.infixOperator, 10, "RIGHT");
   this.defineInfixOperator("%=", this.infixOperator, 10, "RIGHT");
};

XParser.prototype.prefixOperator = function(parser, op) {
   assert('todo implement the prefix operator')
   console.log('prefix operator!!!')
   return ["pre" + op, parser.readE(parser.prefixProperties[op].prec)];
}

XParser.prototype.infixOperator = function(parser, op, lhs) {
   let opStr = op.text
   let exp = parser.readE(parser.infixProperties[opStr].prec)
   return [opStr, lhs, exp];
};

XParser.prototype.suffixOperator = function(parser, op, lhs) {
   assert(false)
   return ["post" + op, lhs];
};

XParser.prototype.parenOperator = function(parser, op) {
   assert(false)
   var exp = parser.readE(0);
   parser.verifyToken(")");
   return exp;
}

XParser.prototype.applyOperator = function(parser, op, lhs) {
   var exp = ["call", lhs.text, lhs.lineNumber];
   var token = parser.nextToken();
   var tokenText = token.text;
   if (tokenText == ")") return exp;
   parser.saveToken(token);
   while (true) {
      exp.push(parser.readE(0));
      token = parser.nextToken();
      tokenText = token.text;
      if (tokenText == ")") break;
      if (tokenText != ',') {
         var msg = "Found \"" + tokenText + "\" when expecting \",\" or \")\"";
         throw new Error(JSON.stringify({
            lineNumber: token.lineNumber,
            msg: msg
         }));
      }
   }
   return exp;
}

XParser.prototype.questionMarkColon = function(parser, op, lhs) {
   console.log('what???')
   var e1 = parser.readE(0);
   parser.verifyToken(":");
   var e2 = parser.readE(parser.infixProperties[op].prec);
   return ["?:", lhs, e1, e2];
};

export default XParser
